import SkeletonText from 'lib/Skeletons/SkeletonText';
import cx from 'classnames';
import SVG from 'react-inlinesvg';
import warningSvg from 'assets/icons/warning.svg';
import { DealSummaryCardSectionProps } from './DealSummaryCardSection.types';

const DealSummaryCardSectionLineStyles = {
  header: {
    label: 'sub-header-base text-essential-primary',
    value: 'header-xl',
  },
  subheader: {
    label: 'body-base text-essential-tertiary',
    value: 'body-lg',
  },
  subheaderSecondary: {
    label: 'body-base text-essential-tertiary',
    value: 'body-lg text-essential-tertiary',
  },
};

const DealSummaryCardSection: React.FC<DealSummaryCardSectionProps> = ({
  id,
  lines = [],
  children,
  isReadOnly,
  isLoading = false,
  errorMessage = '',
}): React.ReactElement => {
  return (
    <div id={id} data-test-id={id} className="flex flex-col rounded-t-xl">
      {errorMessage && (
        <div className="flex items-center gap-x-2 p-2 bg-pinkRed-200 text-pinkRed-950 text-xs rounded-t-xl border-solid border-t border-pinkRed-200">
          <SVG src={warningSvg} />
          <span>{errorMessage}</span>
        </div>
      )}
      <div className="flex flex-col p-3 gap-y-2">
        {lines.length > 0 &&
          lines.map(({ label, value, lineType }) => (
            <div key={`${label}-${value}`} className="flex items-center justify-between">
              {!isLoading ? (
                <>
                  <div className={DealSummaryCardSectionLineStyles[lineType].label}>{label}</div>
                  <div
                    data-test-id={`${id}-value`}
                    className={cx(DealSummaryCardSectionLineStyles[lineType].value, {
                      'text-gray-900 text-opacity-30': isReadOnly,
                    })}
                  >
                    {value}
                  </div>
                </>
              ) : (
                <>
                  <SkeletonText textSizeClass={DealSummaryCardSectionLineStyles[lineType].label} />
                  <SkeletonText textSizeClass={DealSummaryCardSectionLineStyles[lineType].value} />
                </>
              )}
            </div>
          ))}
        {children}
      </div>
    </div>
  );
};

export default DealSummaryCardSection;
